import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { LoginRenderingService } from '../../services/login/login-rendering.service';
import { ReportsLabelEN } from '../../models/labels/reportsLabel_EN';
import { Constants } from '../../models/constants';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  label: any;

  constructor(private router: Router, private loginRenderingService: LoginRenderingService) { }

  ngOnInit() {
    this.loginRenderingService.login.checkHomePage = true;
    this.label = new ReportsLabelEN();
  }

  reports(value) {
    if (value.toUpperCase() === Constants.CONST_ID_STATUS) {
      this.router.navigate(['/approvalStatus']);
    }
    // else if (value.toUpperCase() == Constants.CONST_ID_WORKLOAD)
    //   this.router.navigate(['/workload']);
  }

  onBack() {
    this.router.navigate(['/home']);
  }

}
